import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface ParamsState {
    value: {
        senior: boolean,
        pepperOne: boolean
        flowStep: boolean
    };
}

const initialState: ParamsState = {
    value: {
        senior: false,
        pepperOne: false,
        flowStep: true
    }
}

export const paramsSlice = createSlice({
    name: 'params',
    initialState,
    reducers: {
        showSeniorMode: (state, action: PayloadAction<boolean>) => {
            state.value.senior = action.payload;
        },
        isPepperOne: (state, action: PayloadAction<boolean>) => {
            state.value.pepperOne = action.payload;
        },
        isFlowStep: (state, action: PayloadAction<boolean>) => {
            state.value.flowStep = action.payload;
        }
    },
})

export const { showSeniorMode, isPepperOne, isFlowStep } = paramsSlice.actions;

export default paramsSlice.reducer;